<pf-image
    className="animation__shake"
    src="assets/img/logo.png"
    alt="App Logo"
    height="60"
    width="60"
/>
